export const pxToRem = (px: number, baseFontSize = 16): string => {
  const remValue = px / baseFontSize;
  return `${remValue}rem`;
};
